import Header from "@components/Header/Header"
import { useNavigate, useLocation } from "react-router"
import { useEffect } from "react"
import { E_WALLET_REDEMPTION_LIMIT } from "@constants/transaction"
import { useTranslation } from "react-i18next"
import useEWalletManagement from "@hooks/useManageEWallet"
import LoadingModal from "@components/LoadingModal/LoadingModal"
import useRedemptionLimit from "@hooks/useRedemptionLimit"
import useBalance from "@hooks/useBalance"
import { setHeaderColor } from "@lib/telegram"
import { WHITE } from "@styles/colors"
import RedeemEWalletContent from "./RedeemEWalletContent"
import { Container } from "./RedeemEWallet.styles"

const RedeemEWallet = () => {
  const { supportedEWallets, ewalletAsRedemptionOption, isLoading: isLoadingEWallets, removeEWallet, reload } = useEWalletManagement()
  const { data: redemptionLimit, isLoading: isLoadingRedemptionLimit } = useRedemptionLimit()
  const { data: balance, isLoading: isLoadingBalance } = useBalance()

  const location = useLocation()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleRemoveEWallet = async (ewallet_uuid: string) => {
    await removeEWallet(ewallet_uuid)
    await reload() // Reload the list after deletion
  }

  // E-Wallet Redemption Limit
  const ewalletRemainingLimit = redemptionLimit && Number(redemptionLimit.redeem_request_remaining)
  const preselectedEWallet = ewalletAsRedemptionOption?.length > 0 ? ewalletAsRedemptionOption.find(ewallet => ewallet.id === location.state?.ewallet_uuid) : undefined
  let ewalletTotalDailyLimit = E_WALLET_REDEMPTION_LIMIT
  if (preselectedEWallet) {
    if (supportedEWallets) {
      ewalletTotalDailyLimit = supportedEWallets.find(ewallet => ewallet.provider === preselectedEWallet.provider)?.max_amount || E_WALLET_REDEMPTION_LIMIT
    }
  } else {
    if (supportedEWallets) {
      ewalletTotalDailyLimit = Math.min(...supportedEWallets.map(wallet => wallet.max_amount))
    }
  }

  const prefilledAmount = location.state?.amount as number | undefined

  useEffect(() => {
    setHeaderColor(WHITE)
  }, [])

  return (
    <Container>
      <Header title={t('redeem.header')} showBackButton onBackClick={() => navigate('/transfer')} />

      <LoadingModal
        visible={
          isLoadingEWallets ||
          isLoadingRedemptionLimit ||
          isLoadingBalance
        }
      />

      {
        !isLoadingEWallets && !isLoadingBalance && !isLoadingRedemptionLimit && balance &&
        <RedeemEWalletContent
          currentBalance={balance.confirmed_balance}
          remainingLimit={ewalletRemainingLimit}
          totalDailyLimit={ewalletTotalDailyLimit}
          preselectedEWallet={preselectedEWallet}
          prefilledAmount={prefilledAmount}
          redemptionOptions={ewalletAsRedemptionOption || []}
          supportedEWallets={supportedEWallets}
          onRemoveEWallet={handleRemoveEWallet}
        />
      }

    </Container>
  )
}

export default RedeemEWallet
